import { fields, pairedFields, defaults } from '../goodsWorkbench/batchModifyFilters'

const hitKeys = ['stock', 'brand_id', 'presell', 'quality', 'freight_id', 'is_distribute', 'product_no', 'is_draft', 'has_exposure', 'sku_code', 'sku_name', 'fabric_material', 'has_video', 'quality_problem', 'source_shop_name', 'source_product_id', 'source_title']
export const freshFilters = () => ({ ...defaults(), shop_ids: [] })
export const filterFields = (values, more) => fields
  .filter((field) => !Object.values(pairedFields).includes(field.key) && (!field.more || more))
  .map((field) => ({
    ...field,
    label: field.key === 'platform_product_id' ? '微信商品 ID' : field.label,
    placeholder: field.key === 'platform_product_id' ? '多个 ID 用逗号或空格分隔' : field.placeholder,
    runtime: hitKeys.includes(field.key) || (field.key === 'price' && values.price_mode !== 'product'),
    matchKey: pairedFields[field.key],
    matchOptions: pairedFields[field.key] ? fields.find((item) => item.key === pairedFields[field.key]).options : []
  }))

export const buildFilter = (values) => {
  const filter = { shop_ids: [...values.shop_ids] }
  Object.entries(values).forEach(([key, value]) => {
    if (value !== '' && value != null && !(Array.isArray(value) && !value.length)) filter[key] = typeof value === 'object' ? JSON.parse(JSON.stringify(value)) : value
  })
  if (filter.platform_product_id) filter.platform_product_id = [...new Set(String(filter.platform_product_id).split(/[,，\s]+/).filter(Boolean))]
  return filter
}
